import { Component } from 'opus-angular-seed-core';
@Component({
    bindings: {
        uibModalInstance: '=',
        course: '='
    },
    template: `
        <div class="modal-header">
            <button type="button" class="close" ng-click="vm.uibModalInstance.dismiss()"></button>
            <h2>{{ 'courses.clone course' | translate }}</h2>
        </div>
        <div class="modal-body">
            <form ng-submit="vm.save()">
                <form-wrapper form="vm.form">
                    <form-row error="vm.cloneNameError">
                        <label class="label">{{ 'translation.Course name' | translate }}*</label>
                        <div class="items">
                            <input
                             ng-model="vm.cloneName"
                             type="text" class="form-control"
                             ng-change="vm.validateCloneName()"
                             >
                            <form-row-error ng-show="vm.cloneNameError !== ''">{{ vm.cloneNameError }}</form-row-error>
                        </div>
                    </form-row>
                    <p>{{ "courses.clone course information" | translate }}</p>
                </form-wrapper>
                <button type="submit" class="hidden" >{{ 'general.Save changes' | translate }}</button>
            </form>
        </div>
        <div class="modal-footer">
            <ul class="actions01">
                <li class="primary">
                    <button
                        ng-class="{true: 'loading', false: ''}[vm.isCloningInProgress]"
                        ng-disabled="vm.isCloningInProgress"
                        class="btn main"
                        type="button"
                        ng-click="vm.save()"
                     >{{ 'general.Clone' | translate }}</button>
                </li>
                <li>
                    <button class="btn discrete" type="button" ng-click="vm.uibModalInstance.dismiss()"
                    >{{ 'general.Cancel' | translate }}</button>
                </li>
            </ul>
        </div>
    `
})
export default class {
    constructor ($scope, $state, $translate, CourseResource, toastr) {
        this.$scope = $scope;
        this.$state = $state;
        this.$toastr = toastr;
        this.$translate = $translate;
        this.CourseResource = CourseResource;
        this.cloneName = '';
    }
    $onInit () {
        this.showSaveButton = true;
        this.isCloningInProgress = false;
        this.cloneName = `Copy - ${(this.course.name || '')}`;
    }

    validateCloneName () {
        if (!this.cloneName || this.cloneName.trim() === '') {
            this.cloneNameError = this.$translate.instant('courses.course name is required');
        }
        else if (this.cloneName.length > 255) {
            this.cloneNameError = this.$translate.instant('courses.course name length');
        }
        else {
            this.cloneNameError = '';
        }
    }

    save () {
        this.validateCloneName(); // Ensure validation before save
        if (this.cloneNameError) return; // Prevent saving if validation

        this.showSaveButton = false;
        this.isCloningInProgress = true;
        this.CourseResource.cloneCourse({}, {
            id: this.course.courseId,
            courseName: this.cloneName
        }).$promise
            .then((response) => {
                this.uibModalInstance.close();
                this.$toastr.success(this.$translate.instant('course.Course successfully cloned'));
                this.$state.go('authorized.courses.courses.edit.general', { id: response.id });
            })
            .catch(() => {
                this.uibModalInstance.close();
                this.$toastr.error(
                    this.$translate.instant('course.Failed to clone the course')
                );
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/courses/cloned/index.js